<template>
  <div id="MiniCard" :style="'border: 2px solid #'+ color +';width: 115px;color:#' + color + ';' +CardStyle">
    <p style="font-size:9px;padding-left: 16px;margin: 2px 0 0">{{title}}</p>
    <p style="font-size:28px;text-align: center;margin: 2px 0;line-height: 1em">{{desc}}</p>
  </div>
</template>

<script>
export default {
  name: "MiniCard",
  props: {
    title: {
      type: String,
      required: true
    },
    desc: {
      type: Number,
      required: true
    },
    color: {
      type: String,
      required: false,
      default: "4a90e2"
    },
    CardStyle: {
      type: String,
      required: false,
      default: ""
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/MiniCards/MiniCard.vue